import { GridStateFactory } from '@b2b/common/factories/gridState/types';
import { ApiService } from '@b2b/common/services/api/types';
import { LunchLitelyService, LunchLitelyServiceModule } from '@b2b/common/services/lunchLitely/lunchLitely.service';
import { TODO } from '@b2b/types/core';
import angular, { IScope, ITimeoutService } from 'angular';
import { PosCreatePagesFormsComboEventControllerModule } from '../comboEvent/controllers/PosCreatePagesFormsComboEventController';
import { PosCreatePagesFormsTileControllerModule } from '../tile/controllers/PosCreatePagesFormsTileController';

PosCreatePagesFormsController.$inject = ['$scope', '$timeout', 'ApiService', 'GridStateFactory', 'LunchLitelyService'];

function PosCreatePagesFormsController(
  $scope: IScope & { posCreatePagesForms: TODO },
  $timeout: ITimeoutService,
  apiService: ApiService,
  GridStateFactory: GridStateFactory,
  lunchLitelyService: LunchLitelyService,
) {
  const ctrl = {
    model: {
      type: false as string | false,
      backPaths: ['page'] as string[],
      page: {} as TODO,
    },

    backPaths: ['page'] as string[],

    enablePosComboEvents: false,

    gridState: new GridStateFactory(),

    init() {
      $scope.$on('PosCreatePagesController::Select', ctrl.onPosCreatePagesControllerSelect);
      $scope.$on('PosCreatePagesController::SelectTile', ctrl.onPosCreatePagesControllerSelectTile);

      $scope.$on('PosCreatePagesFormsController::Cancel', ctrl.onPosCreatePagesFormsControllerCancel);

      $scope.$on('PosCreatePagesFormsTileController::Select', ctrl.onPosCreatePagesFormsTileControllerSelect);
      $scope.$on('PosCreatePagesFormsTileController::Cancel', ctrl.onPosCreatePagesFormsTileControllerCancel);

      lunchLitelyService.isEnabled('fe_pos_combos').then((enabled) => {
        ctrl.enablePosComboEvents = enabled;
      });

      ctrl.getEventTemplates();
    },

    getEventTemplates() {
      ctrl.gridState.setPropertyValue('pageSize', 20);

      apiService.program
        .list(false, ctrl.gridState.getGridState())
        .then((response) => ctrl.success.getEventTemplates(response))
        .catch(() => ctrl.error.getEventTemplates());
    },

    isType(type: string | false) {
      return ctrl.model.type === type;
    },

    setType(type: string | false) {
      ctrl.model.type = type;
    },

    success: {
      getEventTemplates(response: TODO) {
        $scope.$broadcast('PosCreatePagesFormsController::TemplatesUpdate', {
          list: response.data.payload.list,
          count: response.data.payload.count,
        });
      },
    },

    error: {
      getEventTemplates() {
        $scope.$broadcast('PosCreatePagesFormsController::TemplatesUpdate', { list: [] });
      },
    },

    onPosCreatePagesControllerSelect(_e: TODO, data: TODO) {
      ctrl.backPaths = ['page'];
      ctrl.setType('page');

      if (data) {
        ctrl.model.page = data;
      }

      $timeout(() => {
        $scope.$broadcast('PosCreatePagesFormsController::UpdatePage', ctrl.model.page);
      }, 0);
    },

    onPosCreatePagesControllerSelectTile(_e: TODO, data: TODO) {
      ctrl.backPaths = ['page'];
      ctrl.setType(data.config.type);

      $timeout(() => {
        $scope.$broadcast('PosCreatePagesFormsController::Update', data);
      }, 0);
    },

    onPosCreatePagesFormsControllerCancel(_e: TODO, data: TODO) {
      let event = 'PosCreatePagesFormsController::Update';
      let form: TODO = {
        config: {
          type: ctrl.backPaths.pop(),
        },
      };

      ctrl.setType(form.config.type);

      if (form.config.type === 'page') {
        event = 'PosCreatePagesFormsController::UpdatePage';
        form = Object.assign({}, form, ctrl.model.page);
      } else {
        form = data;
      }

      $timeout(() => {
        $scope.$broadcast(event, form);
      }, 0);
    },

    onPosCreatePagesFormsTileControllerSelect(_e: TODO, data: TODO) {
      ctrl.backPaths.push('tile');
      ctrl.setType(data.config.type);

      $timeout(() => {
        $scope.$broadcast('PosCreatePagesFormsController::Update', data);
      }, 0);
    },

    onPosCreatePagesFormsTileControllerCancel(e: TODO, data: TODO) {
      $scope.$emit('PosCreatePagesFormsController::RemoveTile', data);
      ctrl.onPosCreatePagesControllerSelect(e, data);
    },
  };

  $scope.posCreatePagesForms = ctrl;
  ctrl.init();
}

export const PosCreatePagesFormsControllerModule = angular
  .module('acme.view.application.pos.create.pages.forms.controllers', [
    'acme.common.service.api',
    'acme.common.factory.gridState',
    LunchLitelyServiceModule,
    'acme.view.application.pos.create.pages.forms.page.controllers',
    PosCreatePagesFormsTileControllerModule,
    'acme.view.application.pos.create.pages.forms.standard.controllers',
    'acme.view.application.pos.create.pages.forms.generalAdmission.controllers',
    'acme.view.application.pos.create.pages.forms.navigation.controllers',
    'acme.view.application.pos.create.pages.forms.addons.controllers',
    'acme.view.application.pos.create.pages.forms.membership.controllers',
    'acme.view.application.pos.create.pages.forms.donations.controllers',
    PosCreatePagesFormsComboEventControllerModule,
  ])
  .controller('PosCreatePagesFormsController', PosCreatePagesFormsController).name;
